import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=1c739db8&scoped=true&"
import script from "./IconCard.vue?vue&type=script&lang=ts&"
export * from "./IconCard.vue?vue&type=script&lang=ts&"
import style0 from "./IconCard.vue?vue&type=style&index=0&id=1c739db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c739db8",
  null
  
)

export default component.exports